import React from "react";
import NewPasswordInner from "../../components/authentication/newPassword/NewPasswordInner";
import FloatingComponents from "../../components/floatingComponents/FloatingComponents";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import ErrorBoundary from "../../helpers/ExceptionHandler/componentException";

const NewPassword = () => {
  const { componentSetting } = useSelector((state) => ({
    componentSetting: state.componentSettingListR.data,
  }));
  return (
    <>
      <ErrorBoundary>
        <NewPasswordInner />
      </ErrorBoundary>
      {typeof componentSetting.floatingComponents != "undefined" &&
        componentSetting.floatingComponents.defaultValue ===
        "right_vertical" && <ErrorBoundary><FloatingComponents /></ErrorBoundary>}
    </>
  );
};

NewPassword.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(NewPassword);
